export const checklist = {
  title: "Your password must have:",
  hasLength8: "8 or more characters.",
  hasLowCap: "Upper and lowercase letters.",
  hasNumber: "At least one number.",
  hasSpecialCharacter: "At least one special character."
};
